import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/session/auth-interceptor';

// Sem provideClientHydration(): app é CSR puro (bootstrapApplication, sem server.ts/builder SSR).
// Com o provider habilitado no client mas nenhum HTML pré-renderizado no servidor, todo boot
// disparava NG0505 no console (ver .docs/qa/console NG0505).
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'disabled' })),
    // Backend XHR (sem withFetch()): o FetchBackend do Angular chama aborter.abort()
    // incondicionalmente no teardown, mesmo após a resposta já ter sido lida por completo —
    // isso faz o Chrome descartar o corpo da resposta em erros no DevTools (Network > Response).
    // Bug conhecido e sem correção: https://github.com/angular/angular/issues/51054.
    provideHttpClient(withInterceptors([authInterceptor])),
  ]
};
